// export const transformFile = (file) => (file ? {
//   ...file,
//   url: config.FILE_STORAGE_ADDRESS + file.url,
// } : file);

export function transformGamesData(data, ...arg) {

  let allData = {};
  for( let d of [...arg]) {
    Object.assign(allData, data[d]);
  };
  let games = [];
  let providers = {};
  let gameTags = {};
  let productsTypes = {};
  for( let provider in allData ) {
    games = [ ...games, ...allData[provider].products.map(g => {return {...g, provider: provider}}) ];
    for ( let game of allData[provider].products ) {
      if (!game.gameType) {
        continue;
      }
      let category = game.gameType;
      if( !providers[category] ) {
        providers[category] = ['all', provider];
      } else if(!providers[category].includes(provider)) {
        providers[category].push(provider);
      }

      if( !gameTags[category] ) {
        gameTags[category] = ['all', ...game.tags];
      } else {
        gameTags[category] = [...gameTags[category], ...game.tags];
      }
      if( !productsTypes[game.gameType] ) {
        productsTypes[game.gameType] = [game.productId];
      } else if(!productsTypes[game.gameType].includes(game.productId)) {
        productsTypes[game.gameType].push(game.productId);
      }
    }
  }
  games.sort((g1, g2) => g2.priority - g1.priority);

  // Keep unique tags only
  for( let category in gameTags ) {
    gameTags[category] = [...new Set(gameTags[category])];
  }
  // console.log('transform: tags:', gameTags);

  // Categories
  //
  const pureCategories = [...new Set(games.map(g => g.gameType))];
  const gameCategories = makeCategoryList(pureCategories);

  return { providers, games, gameTags, gameCategories, productsTypes };
}

export function makeProductList(productList) {
  const arrResult = [];
  for( const prd in productList ) {
    if( Object.keys(productList[prd]).length > 0 ) {
      arrResult.push(prd);
    }
  }
  return arrResult;
}

const makeCategoryList = pureCategories => {
  const arrCategories = [...pureCategories, 'sport', 'virtual'];
  // Embed 'home' for mobile case
  //
  // if( window.innerWidth < 580 ) {
  //   return ['home', ...arrCategories]
  // }
  return arrCategories;
}

// export const transformStaticBanner = (banner) => ({
//   ...banner,
//   background: transformFile(banner.background),
//   image: transformFile(banner.image),
// });

// export const transformConfig = (config) => ({
//   ...config,
//   logo: transformFile(config.logo),
// });
